var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26599 9.765C5.73387 8.34945 6.63685 7.11781 7.84611 6.2458C9.05536 5.37378 10.5091 4.90594 12 4.909C13.69 4.909 15.218 5.509 16.418 6.491L19.91 3C17.782 1.145 15.055 0 12 0C7.26999 0 3.19799 2.698 1.23999 6.65L5.26599 9.765Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0401 18.013C14.9501 18.716 13.5661 19.091 12.0001 19.091C10.5151 19.094 9.06686 18.6299 7.8603 17.7644C6.65373 16.8988 5.75 15.6756 5.27706 14.268L1.23706 17.335C2.22831 19.3413 3.76233 21.0294 5.66488 22.2075C7.56744 23.3857 9.76227 24.0067 12.0001 24C14.9331 24 17.7351 22.957 19.8341 21L16.0411 18.013H16.0401Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.834 21C22.029 18.952 23.454 15.904 23.454 12C23.454 11.29 23.345 10.527 23.182 9.818H12V14.455H18.436C18.119 16.014 17.266 17.221 16.041 18.013L19.834 21Z",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27712 14.268C5.03247 13.5369 4.90819 12.7709 4.90912 12C4.90912 11.218 5.03412 10.467 5.26612 9.765L1.24012 6.65C0.416494 8.31269 -0.00807994 10.1445 0.000116455 12C0.000116455 13.92 0.445116 15.73 1.23712 17.335L5.27712 14.268Z",
    fill: "#FBBC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.52d72fd2.svg";
export { ForwardRef as ReactComponent };